import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import JL from "json-logic-js";
import moment from "moment";
export function applyJsonLogic(logic, data) {
  return JL.apply(logic, data);
}
export function addJsonLogicOperation(name, op) {
  var jl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : JL;
  return jl.add_operation(name, op);
}
export var customJsonLogicOperations = {
  CALL: function CALL(fn, ctx) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return fn.call.apply(fn, [ctx].concat(args));
  },
  JSX: function JSX(type, props) {
    return {
      type: type,
      props: props
    };
  },
  mergeObjects: function mergeObjects(obj1, obj2) {
    return _objectSpread(_objectSpread({}, obj1), obj2);
  },
  fromEntries: function fromEntries(entries) {
    return Object.fromEntries(entries);
  },
  //
  // string
  //
  toLowerCase: function toLowerCase(str) {
    return str.toLowerCase();
  },
  toUpperCase: function toUpperCase(str) {
    return str.toUpperCase();
  },
  strlen: function strlen(str) {
    return (str === null || str === void 0 ? void 0 : str.length) || 0;
  },
  regexTest: function regexTest(str, pattern, flags) {
    return (str === null || str === void 0 ? void 0 : str.match(new RegExp(pattern, flags))) != null;
  },
  //
  // date / datetime
  //
  "date==": function date(a, b) {
    if (a == null || b == null) {
      return false;
    }
    var dateA = moment(a).startOf("day");
    var dateB = moment(b).startOf("day");
    return dateA.isSame(dateB);
  },
  "date!=": function date(a, b) {
    return !customJsonLogicOperations["date=="](a, b);
  },
  "datetime==": function datetime(a, b) {
    if (a == null || b == null) {
      return false;
    }
    var dateA = moment(a);
    var dateB = moment(b);
    return dateA.isSame(dateB);
  },
  "datetime!=": function datetime(a, b) {
    return !customJsonLogicOperations["datetime=="](a, b);
  },
  now: function now() {
    return new Date();
  },
  today: function today() {
    var start = moment().startOf("day");
    var y = start.year();
    var m = start.month();
    var d = start.date();
    // tip: we use UTC to return same result as eg. new Date("2025-05-16")
    var startUtc = moment.utc([y, m, d]);
    return startUtc.toDate();
  },
  start_of_today: function start_of_today() {
    return moment().startOf("day").toDate();
  },
  date_add: function date_add(date, val, dim) {
    return moment(date).add(val, dim).toDate();
  },
  datetime_add: function datetime_add(datetime, val, dim) {
    return moment(datetime).add(val, dim).toDate();
  },
  datetime_truncate: function datetime_truncate(datetime, dim) {
    return moment(datetime).startOf(dim).toDate();
  }
};
export function addRequiredJsonLogicOperations() {
  var jl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : JL;
  for (var k in customJsonLogicOperations) {
    addJsonLogicOperation(k, customJsonLogicOperations[k], jl);
  }
}

/**
 * @deprecated
 */
export var jsonLogicFormatConcat = function jsonLogicFormatConcat(parts) {
  if (parts && Array.isArray(parts) && parts.length) {
    return parts.map(function (part) {
      var _part$value;
      return (_part$value = part === null || part === void 0 ? void 0 : part.value) !== null && _part$value !== void 0 ? _part$value : part;
    }).filter(function (r) {
      return r != undefined;
    });
  } else {
    return undefined;
  }
};

/**
 * @deprecated
 */
export var jsonLogicImportConcat = function jsonLogicImportConcat(val) {
  if (val == undefined) return undefined;
  var errors = [];
  var parts = Array.isArray(val) ? val : [val];
  var res = parts.filter(function (v) {
    return v != undefined;
  }).map(function (v) {
    return {
      type: "property",
      value: val
    };
  });
  if (errors.length) {
    throw new Error(errors.join("\n"));
  }
  return res;
};